/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './converters/index';
export * from './occ-anonymous-consent-templates.adapter';
export * from './occ-customer-coupon.adapter';
export * from './occ-user-address.adapter';
export * from './occ-user-consent.adapter';
export * from './occ-user-interests.adapter';
export * from './occ-user-notification-preference.adapter';
export * from './occ-user-payment.adapter';
export * from './user-occ.module';
